import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import LicenseSearch from 'software_renewal/components/LicenseSearch';
import LicenseDisplay from 'software_renewal/components/LicenseDisplay';
import ProductsToPurchase from 'software_renewal/components/ProductsToPurchase';
import ComplimentarySerialMessage from 'software_renewal/components/ComplimentarySerialMessage';
import EligibleComplimentarySerialNotice from 'software_renewal/components/EligibleComplimentarySerialNotice';
import ViewMateEssentialsPromoSection from 'software_renewal/components/ViewMateEssentialsPromoSection';
import ViewMateProfessionalPromoSection from 'software_renewal/components/ViewMateProfessionalPromoSection';
import FAQs from 'software_renewal/components/FAQs';
import ToasterComponent from 'shared/components/ToasterComponent';
import {
  selectSerialNumberLoaded,
  dataForLicenseDisplay,
  selectLicenseInfo,
} from 'software_renewal/redux/selectors';

const ProductDescription = () => {
  const serialNumberLoaded = useSelector(selectSerialNumberLoaded);
  const licenseInfo = useSelector(dataForLicenseDisplay);
  const fullLicenseInfo = useSelector(selectLicenseInfo);
  const { products } = licenseInfo || {};
  const isFirstRender = useRef(true);

  // Validate presence of complementedBy - must be a non-null object
  const hasComplimentarySerial =
    fullLicenseInfo?.complementedBy != null &&
    typeof fullLicenseInfo.complementedBy === 'object';

  // Check if complimentary serial is within 30 days of expiration
  const complimentaryExpiration = fullLicenseInfo?.complementedBy?.Expiration;

  const isWithin30Days = complimentaryExpiration
    ? dayjs(complimentaryExpiration).diff(dayjs(), 'day') <= 30
    : false;

  // Show ProductsToPurchase if: no complimentary serial OR complimentary serial within 30 days
  const shouldShowProducts = !hasComplimentarySerial || isWithin30Days;

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (serialNumberLoaded) {
      $(`#quick-overview .collapse`).collapse('hide');
    } else {
      $(`#quick-overview .collapse`).collapse('show');
    }
  }, [serialNumberLoaded]);

  const title = serialNumberLoaded
    ? `Results for Renewing Serial ${serialNumberLoaded}`
    : 'Renewals';

  const hasUpgradableProduct = products?.some(({ product }) =>
    [
      'ViewMate Deluxe',
      'ViewMate Pro',
      'CAMMaster',
      'CAMMaster Designer',
    ].includes(product.name),
  );

  return (
    <div
      id="product-description"
      data-hook="product_description"
      className="product-description"
    >
      <ToasterComponent />
      {!hasUpgradableProduct && (
        <div className="row">
          <h1 className="product-title" itemProp="name">
            {title}
          </h1>
        </div>
      )}
      <div className="row">
        <div className="col-12">
          <div id="quick-overview">
            <div className="collapse show">
              <h4 className="subtitle">Renewing your subscriptions is easy!</h4>
              <p className="text-description">
                Renew your ViewMate Essentials, ViewMate Pro & CAMMaster current
                subscription.
              </p>
              <div className="container-fluid px-0">
                <div className="row">
                  <div className="col-12 col-xl-8">
                    <LicenseSearch />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {serialNumberLoaded && (
          <>
            <div className="col-12 mb-3">
              <ViewMateEssentialsPromoSection />
              <ViewMateProfessionalPromoSection />
            </div>
            <div className="col-12 col-xl-5">
              <LicenseDisplay />
            </div>
            <div className="col-12 col-xl-7">
              {shouldShowProducts ? (
                <>
                  <EligibleComplimentarySerialNotice />
                  <ProductsToPurchase />
                </>
              ) : (
                <ComplimentarySerialMessage />
              )}
            </div>
            <div className="col-12">
              <FAQs />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProductDescription;
